import CloseIcon from "@mui/icons-material/Close";
import { Box, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import { useState } from "react";
import { Wheel } from "react-custom-roulette";
import { useDispatch, useSelector } from "react-redux";
import { endPoints } from "../../constant/Environment";
import { addData, getAllData } from "../../Utility/API";
// import { Actions } from "../../../redux/Actions/Actions";
import {Actions} from ".././../redux/Actions/Actions"
import { useNavigate } from "react-router";
import { ErrorToast } from "../../components/Toast/message";
import { SuccesToast } from "../../../../components/Toast/message";

const WheelOfFortune = ({ open, handleClose, wofData }) => {
  const [loading, setLoading] = useState(false);
  const IsLoginData = useSelector((state) => state.auth);
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeIndex, setPrizeIndex] = useState(null);
  const dispatch = useDispatch();
  const Navigate = useNavigate();
   const {
    segments = [],
    probabilities = [],
    colors = [],
    multipliers = [],
    packages = [],
    enables = [],
  } = wofData || {};

  // Original wheel data with proper segments, colors, and probabilities
  const wheelData = {
    "multipliers": [
      "2x", "2x", "3x", "2x", "2x", "2x", "2x", "2x", "5x", "3x", "2x", "2x"
    ],
    "packages": [
      3.99, 3.99, 3.99, 3.99, 4.99, 8.99, 8.99, 8.99, 1.99, 2.99, 8.99, 8.99
    ],
    "probabilities": [
      12, 11, 5, 1, 1, 1, 0, 0, 40, 15, 10, 5
    ],
    "colors": [
      "#22C55E", "#3B82F6", "#FACC15", "#A855F7", "#10B981", "#7C3AED",
      "#FFD700", "#F97316", "#22C55E", "#3B82F6", "#FACC15", "#A855F7"
    ],
    "segments": [
      "0.1 SC", "0.2 SC", "0.5 SC", "1.0 SC", "1.25 SC", "2.0 SC",
      "2.5 SC", "3.0 SC", "5000.0 GC", "75000.0 GC", "12500.0 GC", "15000.0 GC"
    ],
    "enables": [
      true, true, true, true, true, true, true, true, true, true, true, true
    ]
  };

  const data = segments.map((segment, index) => ({
    option: `$${Number(segment)?.toFixed(2)}`,
    style: { backgroundColor: colors[index], textColor: "#000" },
  }));

 const handleSpin = () => {

   if(!IsLoginData?.isAuthenticated){
      handleClose();
      Navigate('/login')
      return;
    }

    // Convert probabilities into cumulative distribution
    const cumulative = probabilities?.reduce((acc, prob, i) => {
      acc.push((acc[i - 1] || 0) + prob);
      return acc;
    }, []);

    // Generate a random number between 0 and total probability
    const totalProb = cumulative[cumulative.length - 1] || 100;
    const rand = Math.random() * totalProb;

    // Find the corresponding index
    const randomIndex = cumulative?.findIndex((value) => rand < value);

    // Check for invalid index and show error toast
    if (randomIndex === -1 || randomIndex === undefined || isNaN(randomIndex)) {
      ErrorToast("Something went wrong with the wheel. Please try again.");
      return;
    }

    setPrizeIndex(randomIndex);
    setMustSpin(true);
  };


  const handleSpinStop = async () => {
    setMustSpin(false);
    
    // Simple reward API call
    const data = {
      userId: IsLoginData?.user?.idUser || null,
      coinResult: segments[prizeIndex] || null,
    };

    // debugger;
    
    try {
      const url = `${endPoints.api.GET_SPIN_PRIZE}`;
      const response = await addData(url, data);
      if (response?.data?.status === "success") {
        // Close wheel and show success
        handleClose();
        GetUserById(); // Update user data after reward
        setPrizeIndex(null); // Reset prize index after spin
        SuccesToast(response?.data?.message || "Congratulations! You've won a prize.");
      }
      else {
        setPrizeIndex(null); // Reset prize index after spin
        ErrorToast(response?.data?.message || "Already claimed! Next reward unlocks in 24 hours.");
        handleClose();
      }
    } catch (error) {
      console.error("Reward API Error:", error);
      handleClose();
      setPrizeIndex(null); // Reset prize index after spin when error occurs
       ErrorToast(
              "Issue connecting to server (error code 15). Please contact support for further assistance."
            );
    }
  };

  const GetUserById = () => {
    if (IsLoginData?.user?.idUser) {
      try {
        let url = `${endPoints.api.GET_BY_USERID}/${IsLoginData?.user?.idUser}`;
        getAllData(url).then((response) => {
          dispatch({
            type: Actions.LOGIN,
            data: { user: response.data },
          });
        });
      } catch (error) {
        console.error("Get User By ID Error:", error);
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        setPrizeIndex(null);
        setMustSpin(false);  // Reset spinning state
        handleClose();
      }}
      maxWidth="sm"
      fullWidth
    >
      <Box
        sx={{
          background: "radial-gradient(circle at center, #0a0a23 40%, #000)",
          color: "#fff",
          textAlign: "center",
          padding: 2,
          position: "relative",
          overflowX: "hidden",
          overflowY: "hidden",
          paddingBottom: "50px",
          height: "120%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {prizeIndex == null && (
        <IconButton
          onClick={() => {
            setPrizeIndex(null);
            setMustSpin(false);  // Reset spinning state
            handleClose();
          }}
          sx={{ position: "absolute", right: 10, top: 10, color: "#fff" }}
        >
          <CloseIcon />
        </IconButton>
      )}
        <Typography variant="h5" fontWeight="bold">
          Spin & Win!
        </Typography>

        {/* Wheel and Centered Spin Button */}
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          position="relative"
          mt={2}
        >
          <Box
            sx={{
              border: { md: "8px solid #FFD700", sm: "6px solid #FFD700" },
              borderRadius: "50%",
              padding: 1,
              backgroundColor: "#111",
            }}
          >
            <Wheel
              mustStartSpinning={mustSpin}
              prizeNumber={prizeIndex}
              data={data}
              onStopSpinning={handleSpinStop}
              outerBorderColor="#FFD700"
              radiusLineColor="#fff"
              radiusLineWidth={1}
              outerBorderWidth={4}
            />
          </Box>
          {prizeIndex == null && (
            <Button
              onClick={handleSpin}
              variant="contained"
              sx={{
                position: "absolute",
                backgroundColor: "#ff004c",
                color: "#fff",
                fontWeight: "bold",
                fontSize: "18px",
                border: "4px solid #fff",
                borderRadius: "50%",
                width: 90,
                height: 90,
                zIndex: 10,
                textTransform: "uppercase",
                boxShadow: "0 0 15px #ff004c",
              }}
            >
              Spin
            </Button>
          )}
        </Box>
      </Box>
    </Dialog>
  );
};

export default WheelOfFortune;
